module.exports = __webpack_public_path__ + "img/前胡.dae1f611.jpg";